import $ from "jquery";

export class Stepper {
    constructor(element, options = {}) {
        this.config = Stepper.mergeSettings(options);
        this.wrapper = typeof element === 'string' ? $(element) : element;

        this.multistep = {
            visitedSteps: [0],
            currentStep: 0
        };
        this.init();
    }

    static mergeSettings(options) {
        const settings = {
            isMultiForm: false,
            multiStepNavElement: '.stepper',
            multiStepNavItem: '.stepper__item',
            multiStepNavActiveClass: 'stepper__item--active',
            multiStepNavCurrentClass: "stepper__item--current",
            multiStepNavNotVisitedClass: "stepper__item--novisited",
            multiStepViewHiddenClass: "step-hidden",
            multiStepViewVisibleClass: "step-visible",
            multiStepViewItems: "[data-step]",
            multiStepButtonNext: "[data-next-step]",
            multiStepButtonPrev: "[data-prev-step]",
            canGoToNextStep: (res) => {
                return false;
            },
        };
        return $.extend(true, {}, settings, options);
    }


    init() {
        this.cacheDOM();
        this.nextButton();
        this.prevButton();
        this.handleStepClicks();
        this.InitFirstStepNav();
    }

    cacheDOM() {
        this.$nextButton = this.wrapper.find(this.config.multiStepButtonNext);
        this.$stepContainer = this.wrapper.find(this.config.multiStepViewItems);
        this.$prevButton = this.wrapper.find(this.config.multiStepButtonPrev);
        this.$stepsParent = $(this.config.multiStepNavElement);
        this.$steps = this.$stepsParent.find(this.config.multiStepNavItem);
    }

    nextButton() {
        let _this = this;
        this.$nextButton.on("click", function (e) {
            e.preventDefault();

            // grab current step and next step parent
            const $this = $(this);

            // if the form is valid hide current step
            // trigger next step
            if (_this.config.canGoToNextStep.call(_this)) {
                const currentParent = $this.closest("[data-step]"),
                    nextParent = currentParent.next();
                currentParent.removeClass(_this.config.multiStepViewVisibleClass);
                _this.showNextStep(currentParent, nextParent);
            }
        });
    }

    prevButton() {
        const _this = this;
        this.$prevButton.on("click", function (e) {
            e.preventDefault();

            // grab current step parent and previous parent
            const $this = $(this),
                currentParent = $this.closest("[data-step]"),
                prevParent = currentParent.prev();

            // hide current step and show previous step
            // no need to validate form here
            currentParent.removeClass(_this.config.multiStepViewVisibleClass);
            _this.showNextStep(currentParent, prevParent);
        });
    }


    showNextStep(currentParent, nextParent) {

        // hide previous parent
        currentParent
            .addClass(this.config.multiStepViewHiddenClass);

        // show next parent
        nextParent
            .removeClass(this.config.multiStepViewHiddenClass)
            .addClass(this.config.multiStepViewVisibleClass);


        // activate appropriate step
        this.handleState(nextParent.index());
    }

    handleState(step) {
        if (this.multistep.visitedSteps.indexOf(step) === -1) {
            this.multistep.visitedSteps.push(step);
        }

        this.$stepsParent.find('.' + this.config.multiStepNavCurrentClass).removeClass(this.config.multiStepNavCurrentClass);
        this.$steps.eq(step).addClass(this.config.multiStepNavActiveClass).addClass(this.config.multiStepNavCurrentClass).removeClass(this.config.multiStepNavNotVisitedClass);
        this.multistep.currentStep = step;
    }

    handleStepClicks() {
        const _this = this;
        const $stepTriggers = this.$steps;

        $stepTriggers.on("click", function (e) {
            e.preventDefault();
            const $this = $(this);
            var btnClickedIndex = $(this).index();

            if (!$this.hasClass(_this.config.multiStepNavActiveClass) || _this.multistep.currentStep === btnClickedIndex) {
                return false
            }

            _this.showNextStep(_this.$stepContainer.eq(_this.multistep.currentStep), _this.$stepContainer.eq(btnClickedIndex))
        });
    }

    InitFirstStepNav() {

        this.$steps.eq(0).addClass(this.config.multiStepNavCurrentClass).removeClass(this.config.multiStepNavNotVisitedClass).addClass(this.config.multiStepNavActiveClass)
    }

}

